import React, { PropsWithChildren } from "react";
import { GenericModalProps } from "../../utils/constants/generic-types";
import { Modal } from "react-bootstrap";
import XIcon from "../icons/XIcon";
import "./CustomModal.scss";

export enum CloseButtonPositions {
  START,
  END,
}

interface CustomModalProps extends GenericModalProps {
  title?: React.ReactNode;
  showTitle?: boolean;
  isFullscreen?: boolean;
  showCloseBtn?: boolean;
  closeBtnPosition?: CloseButtonPositions;
  customClass?: string;
}

export default function CustomModal({
  children,
  isOpen,
  onClose,
  title,
  showTitle = true,
  isFullscreen = false,
  showCloseBtn = true,
  closeBtnPosition = CloseButtonPositions.END,
  customClass = "",
}: PropsWithChildren<CustomModalProps>) {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      fullscreen={isFullscreen ? true : undefined}
      className={`ModalContainer ${customClass}`}
    >
      {(title || showCloseBtn) && (
        <Modal.Header
          className={`${
            title && showTitle
              ? "justify-content-between"
              : "justify-content-end"
          } ${
            closeBtnPosition === CloseButtonPositions.START
              ? "flex-row-reverse"
              : "flex-row"
          } ModalHeader`}
        >
          {title && (
            <Modal.Title className={!showTitle ? "ScreenReaderOnly" : ""}>
              {title}
            </Modal.Title>
          )}
          {showCloseBtn && (
            <button
              aria-label="Close dialog"
              onClick={onClose}
              className="CloseButton"
            >
              <XIcon />
            </button>
          )}
        </Modal.Header>
      )}
      <Modal.Body className="ModalBody">{children}</Modal.Body>
    </Modal>
  );
}
